import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  ListGroup,
  ListGroupItem,
  Grid,
  Col,
  Row,
  Label,
  Glyphicon,
} from 'react-bootstrap';
// icons
import IconArrowUp from 'react-icons/lib/fa/arrow-up';
// models
import Passcode from '../../models/Passcode';
// stores
import PasscodeStore from '../../stores/PasscodeStore';
// components
import PasscodeDialog from '../Property/PasscodeDialog';
import AddPasscodeBtn from '../Buttons/AddPasscode';

import './PasscodeList.css';

const PasscodeList = observer(
class PasscodeList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPasscodeDialog: false,
      selectedPasscode: null,
    };
  }
  render() {
    let {
      passcodes = []
    } = this.props;

    const {
      showPasscodeDialog,
      selectedPasscode,
    } = this.state;

    if (!passcodes.length) {
      return this.renderEmptyState();
    }


    let passcodeListItems = passcodes.map((passcode) => {
      return (
        <PasscodeListItem
          key={passcode.id}
          passcode={passcode}
          onClick={this.onPasscodeListItemClick} />
      );
    });

    return (
      <div className="PasscodeList-container">
        <ListGroup className="PasscodeList-list" >
          {passcodeListItems}
        </ListGroup>
        <PasscodeDialog
          show={showPasscodeDialog}
          passcode={selectedPasscode}
          onSave={this.onPasscodeDlgSave}
          onCancel={this.onPasscodeDlgCancel}
          onDelete={this.onPasscodeDlgDelete} />
      </div>
    );
  }

  renderEmptyState = () => {
    return (
      <div className="PasscodeList-container">
        <div className="PasscodeList-title">
          <AddPasscodeBtn />
        </div>
        <div className="PasscodeList-empty">
          <div className="PasscodeList-empty-icon"><IconArrowUp /></div>
          <div className="PasscodeList-empty-text">Add a few passcodes to get started!</div>
        </div>
      </div>
    )
  }

  onPasscodeListItemClick = (passcode) => {
    this.selectPasscode(passcode);
    this.showPasscodeDialog(true);
    const { onListItemClick } = this.props;
    if (onListItemClick) {
      onListItemClick(passcode);
    }
  }

  onPasscodeDlgSave = (passcode) => {
    if (passcode.id) {
      PasscodeStore.update(passcode);
      this.selectPasscode(null);
      this.showPasscodeDialog(false);
    }
  }

  onPasscodeDlgCancel = () => {
    this.selectPasscode(null);
    this.showPasscodeDialog(false);
  }

  onPasscodeDlgDelete = (passcode) => {
    if (passcode && passcode.id) {
      PasscodeStore.delete(passcode);
    }
    this.selectPasscode(null);
    this.showPasscodeDialog(false);
  }

  selectPasscode = (passcode) => {
    let _passcode = (passcode) ? new Passcode(passcode.get()) : null;
    this.setState({ selectedPasscode: _passcode });
  }

  showPasscodeDialog = (bShow = false) => {
    this.setState({ showPasscodeDialog: bShow });
  }
});

const PasscodeListItem = observer(
class PasscodeListItem extends Component {
  render() {
    const pc = this.props.passcode || {};
    return (
      <ListGroupItem
        onClick={this.onClick} >
        <Grid fluid>
          <Row>
            <Col xs={12} sm={3}>{pc.name}</Col>
            <Col xs={4} sm={3}>{pc.passcode}</Col>
            <Col xs={4} sm={3}>{this.renderEnabledLabel(pc.enabled)}</Col>
            <Col xs={4} sm={3}>{this.renderNotifySms(pc.notifySms)}</Col>
          </Row>
        </Grid>
      </ListGroupItem>
    );
  }

  renderEnabledLabel = (enabled) => {
    let label = enabled ?
                { style: "success", text: "Enabled" } :
                { style: "danger", text: "Disabled" };
    return (
      <Label bsStyle={label.style}>{label.text}</Label>
    )
  }

  renderNotifySms = (notify) => {
    const className = notify ? "PasscodeListItem-smsEnabled" : "PasscodeListItem-smsDisabled";
    return (
      <span className={className}>
        <Glyphicon glyph="comment" />
        <span style={{marginLeft: "5px"}}>sms</span>
      </span>
    );
  }

  onClick = (e) => {
    e.preventDefault();

    const {
      passcode,
      onClick
    } = this.props;

    if (onClick) {
      onClick(passcode);
    }

    return false;
  }
});

export default PasscodeList;


// WEBPACK FOOTER //
// ./src/components/Property/PasscodeList.js